var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"pb-2"},[_c('users'),_c('demo'),_c('consultation'),_c('request-country')],1)}
var staticRenderFns = []

export { render, staticRenderFns }